@if (auth0isAuthenticated() | async) {
    <details>
        <summary>Auth0-session</summary>
        <ap-card title="auth0 login status">
            <div>
                <div>
                    <strong>authenticated: </strong> <span>{{ authenticated }}</span>
                </div>
                <div>
                    <strong>claimExp valid: </strong> <span> {{ claimExp }}</span>
                </div>
                @if (auth.user$ | async; as user) {
                    <div>
                        <strong>Email: </strong> <span>{{ user.email }}</span>
                    </div>
                    <div>
                        <strong>Name: </strong> <span>{{ user.name }}</span>
                    </div>
                    <div>
                        <strong>Party ID: </strong> <span>{{ user['http://asnbank.nl/party_id'] }}</span>
                    </div>
                    <div>
                        <strong>Sub: </strong> <span>{{ user.sub }}</span>
                    </div>
                    <div>
                        <strong>Email verified: </strong> <span>{{ user.email_verified }}</span>
                    </div>
                    <div>
                        <strong>Updated at: </strong> <span>{{ user.updated_at }}</span>
                    </div>
                }
                <div>
                    <br /><br />
                    <ap-button (onClick)="auth0logout()">Uitloggen</ap-button>
                </div>
            </div>
        </ap-card>
    </details>
}
